/**
 * Store data securely on mobile devices (keychain on iOS)
 */
export class SecureStorageService {
	/**
	 * @param {$injector} $injector
	 * @returns {undefined}
	 */
	constructor($injector) {
		'ngInject';
		/**
		 * Use injector to get EventTracker and record setting values in keychain
		 * @type {$injector}
		 */
		this.$injector = $injector;
		/**
		 * Key that gets passed to secureStorage for namespacing purposes
		 * @type {string}
		 */
		this.serviceKey = 'ShareToSharpr';
	}

	/**
	 * Set the value of the given key in secure storage
	 * @param {String} name  The name of the key
	 * @param {String} value  The value to set
	 */
	set(name, value) {
		// don't use SecureStorage on android; we don't read from it on that platform
		// so it's pointless to write to it
		if (!window.cordova || !window.cordova.plugins.SecureStorage || device.platform != 'iOS') {
			return;
		}
		var ss = new window.cordova.plugins.SecureStorage(
			() => this._log('SUCCESS: initialized SecureStorage for writing'),
			error => this._log('ERROR initializing SecureStorage for writing: ' + error),
			this.serviceKey
		);
		ss.set(
			key => this._log('SUCCESS: set SecureStorage key `' + name + '`'),
			error => this._log('ERROR setting SecureStorage key `' + name + '`: ' + error),
			name,
			value
		);
	}

	/**
	 * Get the value of a key in secure storage
	 * @param {String} name  The name of the key
	 * @returns {Promise}  A Promise resolving with the value or rejecting on error
	 */
	get(name) {
		if (!window.cordova || !window.cordova.plugins.SecureStorage) {
			return Promise.resolve(undefined);
		}
		return new Promise((resolve, reject) => {
			var ss = new window.cordova.plugins.SecureStorage(
				() => this._log('SUCCESS: initialized SecureStorage for reading'),
				error => {
					this._log('ERROR initializing SecureStorage for reading: ' + error);
					reject();
				},
				this.serviceKey
			);
			ss.get(
				value => resolve(value),
				error => {
					this._log('ERROR setting SecureStorage key `' + name + '`: ' + error);
					reject();
				},
				name
			);
		});
	}

	/**
	 * Save the outcome of initializing or setting values to the iOS keychain
	 * @param message  The log message
	 * @private
	 */
	_log(message) {
		this.$injector.get('EventTracker').save('keychain', { message });
	}
}
